import { render, staticRenderFns } from "./ClientUsers.vue?vue&type=template&id=382986ea&"
import script from "./ClientUsers.vue?vue&type=script&lang=js&"
export * from "./ClientUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports